import { LetterListResponse } from '../types/letter';

/**
 * Service for fetching letters from the API
 */
class LetterService {
  private baseUrl: string;

  constructor() {
    // Use current origin to support both dev and production environments
    this.baseUrl = window.location.origin;
    console.log(`[LETTER_SERVICE] Initialized with baseUrl: ${this.baseUrl}`);
  }

  /**
   * Fetch letters for a specific tender with pagination support
   * @param companyName - Company name to fetch letters for
   * @param baseCollectionName - Base collection name of the tender
   * @param limit - Number of letters per page (default: 20)
   * @param cursor - Optional pagination cursor from previous request
   * @returns Promise resolving to letter list response
   */
  async getLettersForTender(
    companyName: string,
    baseCollectionName: string,
    limit: number = 20,
    cursor?: string
  ): Promise<LetterListResponse> {
    console.log(`[LETTER_SERVICE] Fetching letters for tender (paginated)`);
    console.log(`[LETTER_SERVICE] Parameters:`, { companyName, baseCollectionName, limit, hasCursor: !!cursor });

    try {
      // Build query parameters
      const params = new URLSearchParams({
        companyName,
        baseCollectionName,
        limit: limit.toString()
      });

      if (cursor) {
        params.append('cursor', cursor);
      }

      const url = `${this.baseUrl}/api/outlook/letters?${params.toString()}`;
      console.log(`[LETTER_SERVICE] Request URL: ${url}`);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `HTTP ${response.status}: ${response.statusText}`
        );
      }

      const result: LetterListResponse = await response.json();
      console.log(`[LETTER_SERVICE] ✅ Successfully fetched ${result.data.items.length} letters (hasMore: ${result.data.hasMore})`);

      return result;

    } catch (error) {
      console.error(`[LETTER_SERVICE] Error fetching letters:`, error);
      throw error;
    }
  }
}

// Export singleton instance
export const letterService = new LetterService();
export default letterService;
